import React, { useState, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { Grid, Stack, TextField, Button, Modal, Fab, Alert, AlertTitle, Snackbar, Paper, AppBar, Box, Toolbar, Typography, useMediaQuery, Checkbox, FormControlLabel, FormControl, FormLabel, Radio, RadioGroup, Card } from '@mui/material';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import SignatureCanvas from 'react-signature-canvas'
import CloseIcon from '@mui/icons-material/Close';
import ConsentPDF from './ConsentPDF';
import { PDFDownloadLink } from "@react-pdf/renderer";
import { API_URL } from '../../../Config/api';
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";
import VerifiedUserOutlinedIcon from "@mui/icons-material/VerifiedUserOutlined";
import PersonOutlineRoundedIcon from "@mui/icons-material/PersonOutlineRounded";
import ConfirmationNumberOutlinedIcon from "@mui/icons-material/ConfirmationNumberOutlined";
import PhoneIphoneOutlinedIcon from "@mui/icons-material/PhoneIphoneOutlined";
import MailOutlineRoundedIcon from "@mui/icons-material/MailOutlineRounded";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import { pdf } from "@react-pdf/renderer";
import GavelOutlinedIcon from "@mui/icons-material/GavelOutlined";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import DrawOutlinedIcon from "@mui/icons-material/DrawOutlined";

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    pt: 2,
    px: 4,
    pb: 3,
};

const ConsentDetails = () => {
    // const port = process.env.REACT_APP_API_KEY;
    const addedby = localStorage.getItem('clg_id');
    const signatureRef = useRef();
    // const { eve_id } = useParams();
    const [eveId, seteveId] = useState(null);
    const [linkStatus, setLinkStatus] = useState("");
    // const eveId = eve_id;
    console.log("consent event id", eveId)


    useEffect(() => {
        const query = window.location.search; // e.g. "?5990" or "?event_id=5990"

        let eveId = null;

        // If the URL has format ?event_id=5990
        if (query.includes("event_id=")) {
            const params = new URLSearchParams(query);
            eveId = params.get("event_id");
        }
        // If the URL has format ?5990
        else if (query.startsWith("?")) {
            eveId = query.substring(1);
        }

        console.log("Extracted Event ID:", eveId);

        if (eveId) {
            seteveId(eveId); // ✅ set event id

        } else {
            setLinkStatus("notFound");
        }
    }, []);


    const [consentDetails, setConsentDetails] = useState([]);
    const [openConsent, setOpenConsent] = useState(false);
    const [viewConsent, setViewConsent] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [selectedSign, setSelectedSign] = useState(null);
    const [selectedFiles, setSelectedFiles] = useState(null);
    const [selectedOption, setSelectedOption] = useState('upload');

    const isSmallScreen = useMediaQuery('(max-width:350px)');
    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const [snackbarSeverity, setSnackbarSeverity] = useState('success');
    const [alreadySubmitConsent, setAlreadySubmitConsent] = useState(false);

    const [errors, setErrors] = useState({
        // selectedOption: '',
        selectedSign: null,
        // selectedFiles: [],
    });

    const handleEmptyField = () => {
        const newErrors = {};

        // if (!selectedOption) {
        //     newErrors.selectedOption = 'This is required';
        // }

        if (selectedOption === 'upload' && !selectedSign) {
            newErrors.selectedSign = 'This field is required';
        }
        // if (!selectedSign) {
        //     newErrors.selectedSign = 'This field is required';
        // }

        // if (!selectedFiles) {
        //     newErrors.selectedFiles = 'This field is required';
        // }
        setErrors(newErrors);
        return Object.values(newErrors).some((error) => error !== '');
    };

    const handleOpenConsent = () => setOpenConsent(true);
    const handleCloseConsent = () => setOpenConsent(false);

    const handleRadioChange = (event) => {
        setViewConsent(event.target.checked);
    };

    const handleSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenSnackbar(false);
        // window.location.reload();
    };

    // const handleFileChange = (event) => {
    //     const files = event.target.files;
    //     const fileObjects = Array.from(files);
    //     setSelectedFiles(fileObjects);
    // };

    const handleFileChange = (event) => {
        const files = event.target.files;
        const fileObjects = Array.from(files);

        if (fileObjects.length === 0) {
            setSelectedFiles(null);
        } else {
            setSelectedFiles(fileObjects);
        }
    };


    const handleSignFileChange = (event) => {
        const files = event.target.files;
        if (files.length > 0) {
            const fileName = files[0];
            setSelectedSign(fileName);
        }
    };

    const getSignature = () => {
        if (signatureRef.current) {
            return signatureRef.current.toDataURL();
        }
        return null;
    };

    const handleOptionChange = (event) => {
        setSelectedOption(event.target.value);
    };

    useEffect(() => {
        const getConsent = async () => {
            try {
                const res = await fetch(`${API_URL}/web/concent_upload_discharge_summery_document_and_signature/${eveId}`,
                );
                if (!res.ok) {
                    throw new Error(`HTTP error! Status: ${res.status}`);
                }
                const data = await res.json();
                // console.log("Consent Deatils.........", data);
                if (data.message === "form already sumitted") {
                    console.log("Form already submitted");
                    setAlreadySubmitConsent(true)
                } else {
                    setConsentDetails(data);
                }

            } catch (error) {
                console.error("Error fetching Consent Details:", error);
            }
        };
        getConsent();
    }, [eveId]);


    async function handleSubmitConsent(e) {
        e.preventDefault();

        if (isSubmitting) return;
        setIsSubmitting(true);

        // ✅ Step 1: Validate required fields
        const hasEmptyFields = handleEmptyField();
        if (selectedOption === "upload" && hasEmptyFields) {
            setOpenSnackbar(true);
            setSnackbarMessage("Please fill * mark fields.");
            setSnackbarSeverity("error");
            return;
        }

        // ✅ Step 2: Prepare signature (either uploaded OR drawn)
        let canvasData = "";
        let signatureFile = null;

        // 🖊️ 1️⃣ Handle Drawn Signature
        if (signatureRef?.current) {
            const drawnData = signatureRef.current.toDataURL("image/png");
            if (drawnData && drawnData.length > 100) {
                const blob = await fetch(drawnData).then((res) => res.blob());
                const fileName = `${consentDetails?.[0]?.eve_id?.agg_sp_pt_id?.name || "drawn_signature"
                    }.png`;
                signatureFile = new File([blob], fileName, { type: "image/png" });
                canvasData = drawnData;
            }
        }

        // 📁 2️⃣ Handle Uploaded Signature
        if (selectedSign && selectedSign instanceof File) {
            // if both exist, prefer uploaded one
            signatureFile = selectedSign;
            canvasData = URL.createObjectURL(selectedSign);
        }

        // 🚨 3️⃣ If no signature at all
        if (!signatureFile) {
            setOpenSnackbar(true);
            setSnackbarMessage("Please provide a signature (upload or draw).");
            setSnackbarSeverity("error");
            return;
        }

        // ✅ Step 3: Prepare FormData
        const formData = new FormData();
        formData.append("eve_id", eveId);
        formData.append("is_aggree", viewConsent ? "True" : "False");
        formData.append("sign", signatureFile);

        if (Array.isArray(selectedFiles) && selectedFiles.length > 0) {
            selectedFiles.forEach((file) =>
                formData.append("Discharge_summ_docs", file)
            );
        } else {
            const emptyFile = new Blob([], { type: "application/octet-stream" });
            formData.append("Discharge_summ_docs", emptyFile, "empty.txt");
        }

        formData.append("clg_id", parseInt(addedby, 10));

        console.log("📤 Uploading Consent Form...");

        try {
            // ✅ Step 4: Upload consent + signature
            const response = await fetch(
                `${API_URL}/web/concent_upload_discharge_summery_document_and_signature/`,
                { method: "POST", body: formData }
            );

            const responseData = await response.json();
            console.log("Consent Upload Response:", responseData);

            if (!response.ok) throw new Error("Consent upload failed!");

            // ✅ Step 5: Generate Consent PDF & Send Email
            console.log("📄 Generating PDF...");
            const pdfBlob = await pdf(
                <ConsentPDF
                    consentDetails={consentDetails}
                    signatureImage={canvasData}
                />
            ).toBlob();

            const pdfFile = new File([pdfBlob], "Consent_Form.pdf", {
                type: "application/pdf",
            });
            const emailForm = new FormData();
            emailForm.append("file", pdfFile);

            console.log("📨 Sending PDF Email...");
            const emailResponse = await fetch(
                `${API_URL}/web/SendConcentEmailAPI/${eveId}/`,
                {
                    method: "POST",
                    body: emailForm,
                }
            );

            const emailResult = await emailResponse.json();
            console.log("Email Response:", emailResult);

            if (emailResponse.ok) {
                setSnackbarMessage("Consent submitted and emailed successfully!");
                setSnackbarSeverity("success");
            } else {
                setSnackbarMessage("Consent saved, but email sending failed.");
                setSnackbarSeverity("warning");
            }

            setOpenSnackbar(true);
            setTimeout(() => window.location.reload(), 1500);
        } catch (error) {
            console.error("❌ Error during submission:", error);
            setSnackbarMessage("Something went wrong. Please try again.");
            setSnackbarSeverity("error");
            setOpenSnackbar(true);
        }
        finally {
            setIsSubmitting(false);
        }
    }


    return (
        <>
            {alreadySubmitConsent ? (
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        height: '100vh',
                    }}>
                    <Alert severity="success" variant="filled">
                        <AlertTitle>Success 🥳</AlertTitle>
                        Your data has been successfully submitted!!.
                    </Alert>

                </div>
            ) : (
                <div>
                    <AppBar
                        position="static"
                        elevation={0}
                        sx={{
                            width: { xs: "96%", md: "92%" },
                            mx: "auto",
                            mt: 0.5,
                            borderRadius: "20px",
                            overflow: "hidden",
                            background: "linear-gradient(120deg, #DCEFEA 0%, #E5F0FA 55%, #E9F4F0 100%)",
                            color: "#234F55",
                            border: "1px solid #A8CEC3",
                        }}
                    >
                        <Toolbar
                            sx={{
                                minHeight: { xs: "100px", md: "115px" },
                                display: "flex",
                                justifyContent: "center",
                                textAlign: "center",
                                px: 2,
                            }}
                        >
                            <Stack spacing={0.8} alignItems="center">
                                <Box
                                    sx={{
                                        width: 38,
                                        height: 38,
                                        borderRadius: "12px",
                                        bgcolor: "rgba(255,255,255,0.17)",
                                        border: "1px solid rgba(255,255,255,0.35)",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                    }}
                                >
                                    <AssignmentTurnedInIcon sx={{ fontSize: 25 }} />
                                </Box>

                                <Typography
                                    sx={{
                                        fontSize: { xs: 15, md: 19 },
                                        fontWeight: 800,
                                        letterSpacing: 1.1,
                                    }}
                                >
                                    SPERO HOME HEALTH CARE
                                </Typography>

                                <Typography
                                    sx={{
                                        fontSize: 12,
                                        letterSpacing: 2,
                                        fontWeight: 500,
                                        color: "blue",
                                    }}
                                >
                                    CONSENT FORM
                                </Typography>
                            </Stack>
                        </Toolbar>
                    </AppBar>

                    <Box sx={{ flexGrow: 1, mb: 2, ml: 1, mr: 1, }}>
                        <div>
                            <Modal
                                open={openConsent}
                                onClose={handleCloseConsent}
                                aria-labelledby="modal-modal-title"
                                aria-describedby="modal-modal-description"
                            >
                                <Box sx={{ ...style, width: 300, borderRadius: "5px" }}>
                                    <div style={{ display: "flex" }}>
                                        <Button onClick={handleCloseConsent} sx={{ marginLeft: "16rem", color: "gray", }}><CloseIcon /></Button>
                                    </div>
                                    <div>
                                        <Typography sx={{ fontSize: 16, fontWeight: 600, }} color="text.secondary" gutterBottom>CALLER DETAILS</Typography>
                                        <Grid container style={{ justifyContent: "space-between", marginTop: "10px" }}>
                                            <Typography inline variant="body2" color="text.secondary">Contact</Typography>
                                            <Typography inline variant="body2" style={{ marginLeft: "15px" }}>{consentDetails[0]?.eve_id?.caller_id?.phone}</Typography>
                                        </Grid>

                                        <Grid container style={{ justifyContent: "space-between", marginTop: "10px" }}>
                                            <Typography inline variant="body2" color="text.secondary">Name</Typography>
                                            <Typography inline variant="body2" >{consentDetails[0]?.eve_id?.caller_id?.caller_fullname}</Typography>
                                        </Grid>
                                    </div>
                                    <hr />

                                    <div>
                                        <Typography sx={{ fontSize: 16, fontWeight: 600, }} color="text.secondary" gutterBottom>PATIENT DETAILS</Typography>

                                        <Grid container style={{ justifyContent: "space-between", marginTop: "10px" }}>
                                            <Typography inline variant="body2" color="text.secondary">Name</Typography>
                                            <Typography inline variant="body2">{consentDetails[0]?.eve_id?.agg_sp_pt_id?.name}</Typography>
                                        </Grid>

                                        <Grid container style={{ justifyContent: "space-between", marginTop: "10px" }}>
                                            <Typography inline variant="body2" color="text.secondary">Mobile</Typography>
                                            <Typography inline variant="body2" >{consentDetails[0]?.eve_id?.agg_sp_pt_id?.phone_no}</Typography>
                                        </Grid>

                                        <Grid container style={{ justifyContent: "space-between", marginTop: "10px" }}>
                                            <Typography inline variant="body2" color="text.secondary">Email Id</Typography>
                                            <Typography inline variant="body2">{consentDetails[0]?.eve_id?.agg_sp_pt_id?.patient_email_id}</Typography>
                                        </Grid>

                                        <Grid container style={{ justifyContent: "space-between", marginTop: "10px" }}>
                                            <Typography inline variant="body2" color="text.secondary">Location</Typography>
                                            <Typography inline variant="body2">Maharashtra, India</Typography>
                                        </Grid>

                                        <Grid container style={{ justifyContent: "space-between", marginTop: "10px" }}>
                                            <Typography inline variant="body2" color="text.secondary">Pincode</Typography>
                                            <Typography inline variant="body2">411051</Typography>
                                        </Grid>

                                        <Grid container style={{ justifyContent: "space-between", marginTop: "10px" }}>
                                            <Typography inline variant="body2" color="text.secondary">Residential Address</Typography>
                                            <Typography inline variant="body2">{consentDetails[0]?.eve_id?.agg_sp_pt_id?.google_address}</Typography>
                                        </Grid>

                                        <Grid container style={{ justifyContent: "space-between", marginTop: "10px" }}>
                                            <Typography inline variant="body2" color="text.secondary">Permanent Address</Typography>
                                            <Typography inline variant="body2">{consentDetails[0]?.eve_id?.agg_sp_pt_id?.address}</Typography>
                                        </Grid>

                                        {/* <Grid container style={{ justifyContent: "space-between", marginTop: "10px" }}>
                                            <Typography inline variant="body2" color="text.secondary">Landline</Typography>
                                            <Typography inline variant="body2">-</Typography>
                                        </Grid>

                                        <Grid container style={{ justifyContent: "space-between", marginTop: "10px" }}>
                                            <Typography inline variant="body2" color="text.secondary">DOB</Typography>
                                            <Typography inline variant="body2">-</Typography>
                                        </Grid> */}
                                    </div>
                                    <hr style={{ borderTop: "1px dashed #000" }} />

                                    <div>
                                        <Grid container style={{ justifyContent: "space-between", marginTop: "10px" }}>
                                            <Typography inline variant="body2" color="text.secondary">Consultant</Typography>
                                            <Typography inline variant="body2">{consentDetails[0]?.doct_cons_id?.cons_fullname}</Typography>
                                        </Grid>

                                        <Grid container style={{ justifyContent: "space-between", marginTop: "10px" }}>
                                            <Typography inline variant="body2" color="text.secondary">Contact No</Typography>
                                            <Typography inline variant="body2">{consentDetails[0]?.doct_cons_id?.mobile_no}</Typography>
                                        </Grid>

                                        <Grid container style={{ justifyContent: "space-between", marginTop: "10px" }}>
                                            <Typography inline variant="body2" color="text.secondary">Email Id</Typography>
                                            <Typography inline variant="body2">{consentDetails[0]?.doct_cons_id?.email_id}</Typography>
                                        </Grid>
                                    </div>
                                </Box>
                            </Modal>
                        </div>

                        <Card
                            elevation={0}
                            sx={{
                                mt: 1.5,
                                width: { xs: "100%", md: "92%" },
                                mx: "auto",
                                border: "1px solid #DCE6F0",
                                borderRadius: "12px",
                                overflow: "hidden",
                                bgcolor: "#FFFFFF",
                            }}
                        >
                            {/* Patient Details - Two Rows */}
                            <Box sx={{ p: 1 }}>
                                {/* First Row - All Four Details */}
                                <Grid container spacing={1}>
                                    {[
                                        {
                                            label: "Patient Name",
                                            value: consentDetails?.[0]?.eve_id?.agg_sp_pt_id?.name,
                                            icon: <PersonOutlineRoundedIcon />,
                                            color: "#1976D2",
                                            bg: "#EAF3FF",
                                        },
                                        {
                                            label: "Event ID",
                                            value: consentDetails?.[0]?.eve_id?.eve_id,
                                            icon: <ConfirmationNumberOutlinedIcon />,
                                            color: "#7952B3",
                                            bg: "#F1EBFC",
                                        },
                                        {
                                            label: "Contact Number",
                                            value: consentDetails?.[0]?.eve_id?.agg_sp_pt_id?.phone_no,
                                            icon: <PhoneIphoneOutlinedIcon />,
                                            color: "#008577",
                                            bg: "#E5F6F2",
                                        },
                                        {
                                            label: "Email Address",
                                            value: consentDetails?.[0]?.eve_id?.agg_sp_pt_id?.patient_email_id,
                                            icon: <MailOutlineRoundedIcon />,
                                            color: "#C47719",
                                            bg: "#FFF3E1",
                                        },
                                    ].map((item, index) => (
                                        <Grid item xs={12} sm={6} md={3} key={index}>
                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: 1,
                                                    p: 1,
                                                    minHeight: 48,
                                                    height: "100%",
                                                    boxSizing: "border-box",
                                                    border: "1px solid #E6EDF5",
                                                    borderRadius: "9px",
                                                    bgcolor: "#FAFCFF",
                                                }}
                                            >
                                                <Box
                                                    sx={{
                                                        width: 30,
                                                        height: 30,
                                                        flexShrink: 0,
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        borderRadius: "8px",
                                                        color: item.color,
                                                        bgcolor: item.bg,
                                                    }}
                                                >
                                                    {React.cloneElement(item.icon, {
                                                        sx: { fontSize: 17 },
                                                    })}
                                                </Box>

                                                <Box sx={{ minWidth: 0, flex: 1 }}>
                                                    <Typography
                                                        sx={{
                                                            fontSize: 10,
                                                            fontWeight: 600,
                                                            color: "#7A899C",
                                                            mb: 0.2,
                                                        }}
                                                    >
                                                        {item.label}
                                                    </Typography>

                                                    <Typography
                                                        sx={{
                                                            fontSize: 12,
                                                            fontWeight: 700,
                                                            color: "#253B53",
                                                            lineHeight: 1.4,
                                                            overflowWrap: "anywhere",
                                                        }}
                                                    >
                                                        {item.value || "—"}
                                                    </Typography>
                                                </Box>
                                            </Box>
                                        </Grid>
                                    ))}
                                </Grid>

                                {/* Second Row - Full Width Address */}
                                <Box
                                    sx={{
                                        mt: 1,
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "flex-start",
                                        textAlign: "left",
                                        gap: 1,
                                        p: 1,
                                        border: "1px solid #F0DCE3",
                                        borderRadius: "9px",
                                        bgcolor: "#FFFAFB",
                                        width: "100%",
                                        boxSizing: "border-box",
                                    }}
                                >
                                    <Box
                                        sx={{
                                            width: 30,
                                            height: 30,
                                            flexShrink: 0,
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            borderRadius: "8px",
                                            color: "#C34D68",
                                            bgcolor: "#FCECF0",
                                        }}
                                    >
                                        <LocationOnOutlinedIcon sx={{ fontSize: 18 }} />
                                    </Box>

                                    <Box sx={{ minWidth: 0, flex: 1, textAlign: "left" }}>
                                        <Typography
                                            sx={{
                                                fontSize: 10,
                                                fontWeight: 600,
                                                color: "#7A899C",
                                                mb: 0.2,
                                                textAlign: "left",
                                            }}
                                        >
                                            Residential Address
                                        </Typography>

                                        <Typography
                                            sx={{
                                                fontSize: 12.5,
                                                fontWeight: 600,
                                                color: "#253B53",
                                                lineHeight: 1.5,
                                                overflowWrap: "anywhere",
                                                textAlign: "left",
                                            }}
                                        >
                                            {consentDetails?.[0]?.eve_id?.agg_sp_pt_id?.address || "—"}
                                        </Typography>
                                    </Box>
                                </Box>
                            </Box>
                        </Card>

                        <Card
                            elevation={0}
                            sx={{
                                mt: 2,
                                width: { xs: "100%", md: "92%" },
                                mx: "auto",
                                border: "1px solid #DCE6F0",
                                borderRadius: "12px",
                                overflow: "hidden",
                                bgcolor: "#FFFFFF",
                            }}
                        >
                            {/* Compact Header */}
                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 1,
                                    px: 1.5,
                                    py: 1.2,
                                    background: "linear-gradient(120deg, #DCEFEA 0%, #E5F0FA 55%, #E9F4F0 100%)",
                                    color: "#234F55",
                                    border: "1px solid #A8CEC3",
                                }}
                            >
                                <GavelOutlinedIcon sx={{ fontSize: 22 }} />

                                <Typography
                                    sx={{
                                        fontSize: 15,
                                        fontWeight: 700,
                                        flex: 1,
                                    }}
                                >
                                    Terms & Conditions
                                </Typography>
                            </Box>

                            {/* Terms Content */}
                            <Box
                                component="ol"
                                sx={{
                                    m: 1,
                                    pl: 1,
                                    listStyleType: "none",
                                    "& li": {
                                        pl: 0,
                                        mb: 1.2,
                                        color: "#1976D2",
                                    },
                                    "& li:last-child": {
                                        mb: 0,
                                    },
                                }}
                            >
                                <Box component="li" sx={{ pl: 0.5, mb: 1.2 }}>
                                    <Typography
                                        component="div"
                                        sx={{
                                            fontSize: 12.5,
                                            color: "#34465A",
                                            lineHeight: 1.7,
                                            textAlign: "justify",
                                            overflowWrap: "anywhere",
                                        }}
                                    >
                                        I, <strong>{consentDetails?.[0]?.eve_id?.agg_sp_pt_id?.name}</strong>,
                                        aged <strong>{consentDetails?.[0]?.eve_id?.agg_sp_pt_id?.Age} years</strong>,
                                        residing at <strong>{consentDetails?.[0]?.eve_id?.agg_sp_pt_id?.address}</strong>,
                                        am suffering from <strong>{consentDetails?.[0]?.eve_id?.agg_sp_pt_id?.Suffered_from}</strong>.
                                    </Typography>
                                </Box>

                                <Box component="li" sx={{ pl: 0.5, mb: 1.2 }}>
                                    <Typography
                                        component="div"
                                        sx={{
                                            fontSize: 12.5,
                                            color: "#34465A",
                                            lineHeight: 1.7,
                                            textAlign: "justify",
                                            overflowWrap: "anywhere",
                                        }}
                                    >
                                        I, <strong>{consentDetails?.[0]?.doct_cons_id?.cons_fullname}</strong>,
                                        aged <strong>{consentDetails?.[0]?.eve_id?.agg_sp_pt_id?.Age} years</strong>,
                                        residing at <strong>{consentDetails?.[0]?.eve_id?.agg_sp_pt_id?.address}</strong>,
                                        am made aware that <strong>{consentDetails?.[0]?.eve_id?.agg_sp_pt_id?.name}</strong>{" "}
                                        is suffering from <strong>{consentDetails?.[0]?.eve_id?.agg_sp_pt_id?.Suffered_from}</strong>.
                                    </Typography>
                                </Box>

                                <Box
                                    component="ol"
                                    sx={{
                                        m: 0,
                                        pl: 2.5,
                                        "& li": {
                                            pl: 0.5,
                                            mb: 1.2,
                                            color: "#1976D2",
                                        },
                                        "& li:last-child": {
                                            mb: 0,
                                        },
                                    }}
                                >
                                    {[
                                        <>
                                            That, above named patient has been receiving treatment from a consultant for the mentioned disease.
                                        </>,
                                        <>
                                            That, above named consultant has explained that the patient can now receive treatment/care at home.
                                        </>,
                                        <>
                                            That, Spero Home Health Care professional has explained to us all the details, including limitations, advantages, disadvantages, effects, side-effects, pros, cons, etc., of Home Health Care.
                                        </>,


                                        <>
                                            That, after understanding the limitations of Home Health Care in detail, I freely consent to the provision of Home Health Care, including{" "}
                                            {consentDetails?.[0]?.eve_id?.service},
                                            {" "}for {consentDetails?.[0]?.eve_id?.sub_service} to{" "}
                                            {consentDetails?.[0]?.eve_id?.agg_sp_pt_id?.name}.
                                        </>,

                                        <>
                                            That, we have been informed by a Spero professional that Spero Home Health Care is solely involved in executing medical instructions, advice, and orders from the respective consultant. Furthermore, we have been informed that we shall contact or consult the concerned consultant/hospital for any further medical management of the disease condition.
                                        </>,
                                        <>
                                            That, we have been informed by a Spero professional that we shall adhere to all instructions, advice, and orders provided by the hospital through the concerned consultant. Additionally, we will consult or visit the relevant consultant/hospital for any necessary follow-up.
                                        </>,
                                        <>
                                            That, we assure that we will not directly hire or avail Home Health Care services from any representative, professional, or employee of Spero Home Healthcare Pvt. Ltd. in any form.
                                        </>,
                                        <>
                                            We assure that the safety and security of the Spero Professional while rendering services at our home/premises will be our responsibility and liability.
                                        </>,
                                        <>
                                            We have been made aware that Spero does ‘Police Clearance/Verification’ of its every professional before availing Home Health Care services from such professional. Still if any Spero professional while rendering Home Health Care services is involved in any criminal activities including theft, violence, damage, injury, etc. in that case patient/relatives are at liberty to initiate police complaint against such professional. Spero Home Healthcare Pvt. Ltd. shall not be held responsible & liable for such an offense allegedly committed by such a professional in his/her individual capacity.
                                            We assure and take responsibility of keeping valuables, cash, jewellery, documents, electronic devices and other personal belongings in a safe & secure place having no access to Spero Professional.
                                        </>,
                                    ].map((term, index) => (
                                        <Box
                                            component="li"
                                            key={index}
                                            sx={{
                                                pl: 0.5,
                                                "&::marker": {
                                                    fontSize: 12,
                                                    fontWeight: 700,
                                                },
                                            }}
                                        >
                                            <Typography
                                                component="div"
                                                sx={{
                                                    fontSize: 12.5,
                                                    color: "#34465A",
                                                    lineHeight: 1.7,
                                                    textAlign: "justify",
                                                    overflowWrap: "anywhere",
                                                }}
                                            >
                                                {term}
                                            </Typography>
                                        </Box>
                                    ))}
                                </Box>

                                {/* Compact Note */}
                                <Paper
                                    elevation={0}
                                    sx={{
                                        mt: 1.8,
                                        p: 1.5,
                                        bgcolor: "#FFF9E9",
                                        border: "1px solid #F3D68A",
                                        borderRadius: "9px",
                                    }}
                                >
                                    <Box
                                        sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: 0.8,
                                            mb: 1,
                                            color: "#9A6700",
                                        }}
                                    >
                                        <InfoOutlinedIcon sx={{ fontSize: 19 }} />

                                        <Typography
                                            sx={{
                                                fontSize: 13,
                                                fontWeight: 700,
                                            }}
                                        >
                                            Important Note
                                        </Typography>
                                    </Box>

                                    <Box
                                        component="ol"
                                        sx={{
                                            m: 0,
                                            pl: 2.5,
                                            "& li": {
                                                pl: 0.3,
                                                mb: 1,
                                                color: "#B7791F",
                                            },
                                            "& li:last-child": {
                                                mb: 0,
                                            },
                                        }}
                                    >
                                        <Box component="li">
                                            <Typography
                                                sx={{
                                                    fontSize: 12.5,
                                                    lineHeight: 1.7,
                                                    color: "#51452B",
                                                    textAlign: "justify",
                                                }}
                                            >
                                                Furthermore, we have been made to understand that Spero is a distinct and independent legal entity from the hospital. Spero will be solely responsible, liable, and answerable for Home Health Care services provided to the patient. The hospital will not be responsible, liable, or answerable for the policies, practices, and Home Health Care services provided by Spero, and any untoward event arising thereof. Therefore, in case of queries or feedback regarding Home Health Care services, etc., we would contact Spero.
                                            </Typography>
                                        </Box>

                                        <Box component="li">
                                            <Typography
                                                sx={{
                                                    fontSize: 12.5,
                                                    lineHeight: 1.7,
                                                    color: "#51452B",
                                                    textAlign: "justify",
                                                }}
                                            >
                                                We have been explained above information in our vernacular i.e. Marathi/Hindi and after satisfaction, we are putting our signatures at place and date mentioned here in below.
                                            </Typography>
                                        </Box>
                                    </Box>
                                </Paper>
                            </Box>
                        </Card>

                        <Card
                            elevation={0}
                            sx={{
                                mt: 2,
                                width: { xs: "100%", md: "92%" },
                                mx: "auto",
                                border: "1px solid #DCE6F0",
                                borderRadius: "12px",
                                overflow: "hidden",
                                bgcolor: "#FFFFFF",
                            }}
                        >
                            {/* Compact Header */}
                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 1,
                                    px: 1.5,
                                    py: 1.2,
                                    color: "#234F55",
                                    background: "linear-gradient(120deg, #DCEFEA 0%, #E5F0FA 55%, #E9F4F0 100%)",
                                    border: "1px solid #A8CEC3",
                                }}
                            >
                                <VerifiedUserOutlinedIcon sx={{ fontSize: 21 }} />

                                <Typography sx={{ fontSize: 15, fontWeight: 700 }}>
                                    Consent Confirmation
                                </Typography>
                            </Box>

                            {/* Content */}
                            <Box sx={{ p: { xs: 1, sm: 1.5 } }}>
                                <Grid container spacing={1.2} alignItems="stretch">

                                    {/* Agree */}
                                    <Grid item xs={12} sm={6} lg={3}>
                                        <Paper
                                            variant="outlined"
                                            sx={{
                                                height: "100%",
                                                minHeight: 70,
                                                p: 1.2,
                                                display: "flex",
                                                alignItems: "center",
                                                borderRadius: "9px",
                                                borderColor: viewConsent ? "#81C784" : "#E2EAF2",
                                                bgcolor: viewConsent ? "#F1FAF3" : "#FFFFFF",
                                                boxSizing: "border-box",
                                            }}
                                        >
                                            <FormControlLabel
                                                sx={{
                                                    m: 0,
                                                    "& .MuiFormControlLabel-label": {
                                                        fontSize: 12.5,
                                                        fontWeight: 600,
                                                        color: "#34465A",
                                                    },
                                                }}
                                                control={
                                                    <Checkbox
                                                        checked={viewConsent}
                                                        onChange={handleRadioChange}
                                                        size="small"
                                                        sx={{
                                                            color: "#1976D2",
                                                            "&.Mui-checked": { color: "#16805D" },
                                                            p: 0.75,
                                                        }}
                                                    />
                                                }
                                                // label="Agree with the consent"
                                                label={
                                                    <>
                                                        I read above mentioned contents,
                                                        <br />
                                                        I accept and agree with above all.
                                                    </>
                                                } />
                                        </Paper>
                                    </Grid>

                                    {/* Signature Option */}
                                    <Grid item xs={12} sm={6} lg={3}>
                                        <Paper
                                            variant="outlined"
                                            sx={{
                                                height: "100%",
                                                minHeight: 70,
                                                p: 1.2,
                                                display: "flex",
                                                flexDirection: "column",
                                                justifyContent: "center",
                                                borderRadius: "9px",
                                                borderColor: "#E2EAF2",
                                                boxSizing: "border-box",
                                            }}
                                        >
                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: 0.7,
                                                    mb: 0.5,
                                                }}
                                            >
                                                <DrawOutlinedIcon
                                                    sx={{ fontSize: 17, color: "#1976D2" }}
                                                />
                                                <Typography
                                                    sx={{
                                                        fontSize: 11,
                                                        fontWeight: 700,
                                                        color: "#64748B",
                                                    }}
                                                >
                                                    SIGNATURE METHOD
                                                </Typography>
                                            </Box>

                                            <RadioGroup
                                                row
                                                value={selectedOption}
                                                onChange={handleOptionChange}
                                                sx={{
                                                    flexWrap: "nowrap",
                                                    "& .MuiFormControlLabel-root": {
                                                        ml: 0,
                                                        mr: 1.5,
                                                    },
                                                    "& .MuiFormControlLabel-label": {
                                                        fontSize: 12,
                                                        fontWeight: 500,
                                                    },
                                                }}
                                            >
                                                <FormControlLabel
                                                    value="upload"
                                                    control={<Radio size="small" />}
                                                    label="Upload"
                                                />

                                                <FormControlLabel
                                                    value="add"
                                                    control={<Radio size="small" />}
                                                    label="Draw"
                                                />
                                            </RadioGroup>
                                        </Paper>
                                    </Grid>

                                    {/* Signature Upload / Draw */}
                                    <Grid item xs={12} sm={6} lg={3}>
                                        <Paper
                                            variant="outlined"
                                            sx={{
                                                minHeight: 70,
                                                height: "100%",
                                                p: 1,
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                borderRadius: "9px",
                                                borderColor: "#E2EAF2",
                                                boxSizing: "border-box",
                                                overflow: "hidden",
                                            }}
                                        >
                                            {selectedOption === "upload" ? (
                                                <TextField
                                                    fullWidth
                                                    size="small"
                                                    type="file"
                                                    label="Upload Signature"
                                                    InputLabelProps={{ shrink: true }}
                                                    onChange={handleSignFileChange}
                                                    sx={{
                                                        "& .MuiInputBase-root": {
                                                            fontSize: 12,
                                                        },
                                                        "& .MuiInputLabel-root": {
                                                            fontSize: 12,
                                                        },
                                                    }}
                                                />
                                            ) : (
                                                <Box sx={{ width: "100%", textAlign: "center" }}>
                                                    <Typography
                                                        sx={{
                                                            fontSize: 10,
                                                            fontWeight: 600,
                                                            color: "#64748B",
                                                            mb: 0.5,
                                                        }}
                                                    >
                                                        Draw your signature
                                                    </Typography>

                                                    <Box
                                                        sx={{
                                                            width: "100%",
                                                            display: "flex",
                                                            justifyContent: "center",
                                                            overflowX: "auto",
                                                        }}
                                                    >
                                                        <SignatureCanvas
                                                            ref={signatureRef}
                                                            penColor="black"
                                                            canvasProps={{
                                                                width: 220,
                                                                height: 60,
                                                                style: {
                                                                    maxWidth: "100%",
                                                                    border: "1px dashed #90CAF9",
                                                                    borderRadius: 6,
                                                                    background: "#FAFCFF",
                                                                },
                                                            }}
                                                        />
                                                    </Box>
                                                </Box>
                                            )}
                                        </Paper>
                                    </Grid>

                                    {/* Discharge Summary */}
                                    <Grid item xs={12} sm={6} lg={3}>
                                        <Paper
                                            variant="outlined"
                                            sx={{
                                                minHeight: 70,
                                                height: "100%",
                                                p: 1,
                                                display: "flex",
                                                alignItems: "center",
                                                borderRadius: "9px",
                                                borderColor: "#E2EAF2",
                                                boxSizing: "border-box",
                                            }}
                                        >
                                            <TextField
                                                fullWidth
                                                size="small"
                                                type="file"
                                                label="Discharge Summary"
                                                InputLabelProps={{ shrink: true }}
                                                inputProps={{ multiple: true }}
                                                onChange={handleFileChange}
                                                sx={{
                                                    "& .MuiInputBase-root": {
                                                        fontSize: 12,
                                                    },
                                                    "& .MuiInputLabel-root": {
                                                        fontSize: 12,
                                                    },
                                                }}
                                            />
                                        </Paper>
                                    </Grid>

                                </Grid>
                            </Box>
                        </Card>

                        {viewConsent && (
                            <Grid item lg={12} md={12} xs={12} sx={{ mt: 1, mb: 2 }}>
                                <Button variant='contained' sx={{ textTransform: "capitalize", width: "20ch", borderRadius: "10px" }}
                                    onClick={handleSubmitConsent}
                                    disabled={isSubmitting}
                                >Submit</Button>
                            </Grid>

                        )}

                        {/* <Grid item lg={12} md={12} xs={12} sx={{ mt: 2, mb: 4 }}>
                            <PDFDownloadLink
                                document={<ConsentPDF consentDetails={consentDetails} />}
                                fileName={`Consent_Form_${consentDetails[0]?.eve_id?.agg_sp_pt_id?.name || "Patient"}.pdf`}
                                style={{
                                    textDecoration: "none",
                                    padding: "8px 16px",
                                    color: "white",
                                    backgroundColor: "#0E8FE4",
                                    borderRadius: "6px",
                                    fontWeight: 500,
                                }}
                            >
                                {({ loading }) =>
                                    loading ? "Generating PDF..." : "Preview / Download Consent PDF"
                                }
                            </PDFDownloadLink>
                        </Grid> */}

                        <Grid item lg={12} md={12} sm={12} xs={12}>
                            <Snackbar
                                open={openSnackbar}
                                autoHideDuration={6000}
                                onClose={handleSnackbarClose}
                            >
                                <Alert variant="filled"
                                    onClose={handleSnackbarClose}
                                    severity={snackbarSeverity}
                                    sx={{ width: '100%', mb: 15 }}
                                >
                                    {snackbarMessage}
                                </Alert>
                            </Snackbar>
                        </Grid>
                    </Box>
                </div>
            )}
        </>
    )
}

export default ConsentDetails
